import { useRefArmourMaterials } from './useRefArmourMaterials'
import {
  computeEndurance, computeTotalInjuryLevels,
  computeUniversalPenalty, computePhysicalPenalty,
  computeArmourByLocation, getArmourTier, calcEffectiveEP,
} from '../lib/computedStats'

export function useComputedStats(character: any) {
  const { data: armourMaterials } = useRefArmourMaterials()

  const endurance = computeEndurance(character)
  const totalInjury = computeTotalInjuryLevels(character.injuries ?? [])
  const up = computeUniversalPenalty(totalInjury, character.fatigue_levels ?? 0)

  const wornArmour = (character.armour ?? []).filter((a: any) => a.is_worn)
  const armourTier = getArmourTier(wornArmour)
  const armourSkillName = armourTier === 'harness' ? 'Armour Harness'
                        : armourTier === 'mail'    ? 'Armour Mail'
                        : armourTier === 'light'   ? 'Armour Light'
                        : null
  const armourML = armourSkillName
    ? ((character.skills ?? []).find((s: any) => s.skill_name === armourSkillName)?.ml ?? 0)
    : 0
  const armourWeightLbs = wornArmour.reduce((sum: number, a: any) => sum + (a.weight_lbs ?? 0), 0)
  const ep = calcEffectiveEP(armourWeightLbs, endurance, character.fatigue_levels ?? 0, armourML, false)
  const pp = computePhysicalPenalty(up, ep)

  const armourProtection = armourMaterials
    ? computeArmourByLocation(wornArmour, armourMaterials)
    : {}

  return { endurance, up, ep, pp, armourProtection }
}
